import React, { useEffect } from 'react';
import { WithBackendConfig } from '../../providers/BackendConfigProvider/BackendConfigProvider';
import { get } from 'lodash';
import { redirectTo } from '../../utils/utils';

const ExternalSignUp = ({ backendConfig }) => {
  useEffect(() => {
    async function updateSignupUrl() {
      const signupLink = await get(backendConfig, 'signUpLink.nighthawk');
      redirectTo(signupLink);
    }
    updateSignupUrl();
  }, [backendConfig]);

  return <section>Redirecting...</section>;
};

export { ExternalSignUp };
export default WithBackendConfig(ExternalSignUp);
